module.exports = __webpack_public_path__ + "img/UTKODA.fa913a5f.png";